export default {
  "hierarchy": {
    "pagination": [
      "combobox-pagination"
    ],
    "paginationInput": [
      "combobox-paginationInput"
    ]
  },
  "props": {
    "default": {
      "selectIcon": "lv lv-chevron-down"
    },
    "pagination": {
      "selectIcon": "fak fa-lv-chevron-down-small"
    },
    "paginationInput": {
      "selectIcon": "lv lv-chevron-down"
    }
  }
}